export const ROUTE_PATH = '/download-app';
